import type { ContentStatus, ReviewStatus } from '@platform/schema/content';

/**
 * How the console colours a row's status — GEN-58.
 *
 * Exhaustive over `ContentStatus`, for the reason `JOB_COLOUR` gives one screen over: a
 * fourth status should not compile until somebody has decided how the library shows it.
 *
 * `ARCHIVED` is `default` rather than `error`. It is a deliberate act by a person, not a
 * fault, and colouring it red would read as something to go and fix.
 */
export const STATUS_COLOUR: Record<
  ContentStatus,
  'default' | 'info' | 'success'
> = {
  DRAFT: 'info',
  PUBLISHED: 'success',
  ARCHIVED: 'default',
};

/** A suffix rather than a hidden row: archived paths stay listed as history. */
export const archived = (status: ContentStatus): string =>
  status === 'ARCHIVED' ? ' (Archived)' : '';

/** What a lesson's review status reads as. Exhaustive for the reason `STATUS_COLOUR` is. */
export const REVIEW_SHOWN: Record<
  ReviewStatus,
  { label: string; colour: 'warning' | 'success' | 'error' }
> = {
  NEEDS_REVIEW: { label: 'Needs review', colour: 'warning' },
  APPROVED: { label: 'Approved', colour: 'success' },
  NEEDS_CHANGES: { label: 'Needs changes', colour: 'error' },
};
